export const alarmStatusColorState = {
    errorCode : 0,
    statusCode : 0,
    alarmStatusColorList : [],
    message : '',
    isLoading : false,
    regionList:[],
}
